export const getUserDetailsQuery = `query GetUserDetails($id: String!) {
    getUserDetails(id: $id) {
        detail {
            source
            role
            pool
            id
            environment
            createdDate
            application
            active
        }
        user {
            workingTitle
            nameN
            name
            idmuid
            emplid
            emplStatus
            deptidDescr
            affiliations
            isStudent
            enrollmentStatus
            homeCampus
            acadCareer
            acadProgDescr
            progStatus
            biodemoSource
        }
      }
  }`;
  